import Swiper from "swiper";
import { find } from "utils/dom";
import { gsap } from "gsap";

export default function () {
	const Single = find("[js-page='single']");
	if (!Single) return;

	document.addEventListener('DOMContentLoaded', function () {
		const swiperTeam = new Swiper('.swiper-team', {
			slidesPerView: 4,
			centeredSlides: false,
			speed:1000,
			spaceBetween: 20,
			navigation: {
				nextEl: '.single-team-container .team-button-next',
				prevEl: '.single-team-container .team-button-prev',
			},
		});
	});	
}
